import { FooterContainer } from '../styles/StakeholderRatingsFooterStyles'
import {
  StakeholderCTAItem,
  StakeholderCTAInfo,
  StakeholderCTADetails,
  StakeholderCTAName,
  StakeholderCTARole,
} from '../styles/StakeholderCTAStyles'
import type { CategoryStyle } from '../types'

interface EmptyStateProps {
  categoryStyle: CategoryStyle
}

/**
 * Shown when no stakeholder ratings exist yet.
 * Stakeholder CTAs (asking specific raters for feedback) are rendered separately
 * by StakeholderCTAList in the expanded accordion view.
 */
export function EmptyState({ categoryStyle }: EmptyStateProps): React.JSX.Element {
  return (
    <FooterContainer $borderColor={categoryStyle.borderColor}>
      <StakeholderCTAItem
        className="nodrag"
        $accentColor={categoryStyle.accentColor}
        $isLoading={false}
      >
        <StakeholderCTAInfo>
          <StakeholderCTADetails>
            <StakeholderCTAName>No ratings yet</StakeholderCTAName>
            <StakeholderCTARole>Ask a stakeholder for feedback to get started</StakeholderCTARole>
          </StakeholderCTADetails>
        </StakeholderCTAInfo>
      </StakeholderCTAItem>
    </FooterContainer>
  )
}
